import { Component, ViewChild } from "@angular/core";
import { BaseListComponent } from "../../SharedModule/BaseListComponent/base-list.component";
import { Pagination } from "../../model/Helpers/Pagination";
import { SortInfo } from "../../model/Helpers/SortInfo";
import { Filter } from "../../model/Helpers/Filter";
import { MatSort } from "@angular/material/sort";
import { merge } from "rxjs/observable/merge";
import {TransportStatsService} from '../../services/transport-stats.service';
import {TransportStatsDataSource} from '../../model/DataSources/TransportStatsDataSource';
import {TransportDataSource} from '../../model/DataSources/TransportDataSource';
import {TransportService} from '../../services/transport.service';
import {ContractState} from '../../model/Entities/ContractState';
import {Contract} from '../../model/Entities/Contract';
import { Router } from '@angular/router';
import {Transport} from '../../model/Entities/Transport';
import {TransportDialogComponent} from '../../ContractsModule/TransportDialogComponent/transport.dialog.component';
import {DialogService} from '../../services/dialog.service';
import {SnackService} from '../../services/snack.service';
import {
    TransportDeleteConfirmDialogComponent
} from '../../ContractsModule/TransportDeleteConfirmDialogComponent/transport-delete-confirm.dialog.component';
import {CompleteTransportDialogComponent} from '../CompleteTransportDialogComponent/completeTransport.dialog.component';
import {UserService} from '../../services/user.service';
import {User} from '../../model/Entities/User';
import {PrintService} from '../../services/print.service';
import {ContractStateComponent} from '../../SharedModule/ContractStateComponent/contract-state.component';
import {BarcodeService} from '../../services/barcode.service';
import {ContractService} from '../../services/contract.service';
import {
    ContractItemsTransferDialogComponent
} from '../../ContractsModule/ContractItemsTransferDialogComponent/contract-items-transfer.dialog.component';

@Component({
    selector: 'transport-agenda',
    templateUrl: './transportAgenda.component.html',
    styleUrls: ['./transportAgenda.component.scss']
})
export class TransportAgendaComponent extends BaseListComponent {


    public transports: Transport[] = [];
    public showQrTransportId = null;
    public user: User = this.userService.getLoggedUser();

    constructor(
        private transportService: TransportService,
        private userService: UserService,
        private router: Router,
        private contractService: ContractService,
        private dialogService : DialogService,
        private snackService: SnackService,
        public barcodeService: BarcodeService,

    ) {
        super();

        this.loadTransport();

    }

    public showQrTransport(transport: Transport): void {
        if (this.showQrTransportId > 0 && this.showQrTransportId === transport.id) {
            this.showQrTransportId = 0;
            return;
        }

        this.showQrTransportId = transport.id;
    }

    hideQrTransport() {
        this.showQrTransportId = null;
    }

    completeTransport(transport) {
        if (transport.contract) {
            transport.completePerson = transport.contract.delivery_contact_person;
        }
        transport.completeDatetime = new Date().toISOString().slice(0, 16);
        transport.completeUserId = this.user;

        this.dialogService.showDialog(CompleteTransportDialogComponent, {
            'transport': transport
        }).afterClosed().subscribe((result: any) => {
            if (result) {
                this.transportService.update(result.id, transport).subscribe((t: Transport) => {
                    this.snackService.showSuccess(`Dokončení dopravy uloženo!`);
                    this.loadTransport();
                });
            } else {
                this.loadTransport();
            }
        });
    }

    private loadTransport(): void {
        this.transportService.getSimpleList([
            new Filter('user_id', this.userService.getLoggedUser().id),
            new Filter('actual', true),
        ], { expand: 'users,contract,repeatTransport' }).subscribe((transports: Transport[]) => {
            this.transports = transports;
        })
    }

    showContractDetail(contract: Contract): void {
        this.router.navigate([`/contract/${contract.id}`]);
    }


    ngAfterViewInit() {
    }


    onDateChange(): void {
        // When user manually changes dates, switch to custom period
        this.filters.predefinedPeriod = "custom";
        this.reloadPage();
    }

    protected readonly ContractState = ContractState;

    changeState(contract: Contract, state: ContractState) {
        this.contractService.update(contract.id, { state: state }).subscribe((c: Contract) => {
            this.snackService.showSuccess(`Stav změněn`);
            this.loadTransport();
        });
    }

    public openTransferDialog(direction: any, contract: any): void {
        this.dialogService.showDialog(ContractItemsTransferDialogComponent, {
            'contract': contract,
            'direction': direction
        }, 1000).afterClosed().subscribe((result: any) => {
        });
    }

}



// WEBPACK FOOTER //
// /app/src/TransportModule/TransportAgendaComponent/transportAgenda.component.ts